import Entity from "./entity";
import Glyphs from "../glyphs";
import Weapons from "./weapons";
import Description from "./description";
import Item from "./item";

class Items {
  static handMirror() {
    return Item.make(
      "Gothic",
      Glyphs.CircleBulb,
      "Hand Mirror",
      "An elegant little mirror that reflects the surrounding light from its polished surface."
    );
  }

  static fishhook() {
    return Item.make(
      "Rustic",
      Glyphs.Fishhook,
      "Fish Hook",
      "A tiny barbed hook used for baiting and snagging fish by their mouths."
    );
  }

  static ironNail() {
    return Item.make(
      "Ramshackle",
      Glyphs.IronNail,
      "Iron Nail",
      "A rusty little iron nail."
    );
  }

  static crackedPot() {
    return Item.make(
      "Ramshackle",
      Glyphs.CrackedPot,
      "Cracked Pot",
      "A cracked pot made from ochre clay."
    );
  }

  static ratSkull() {
    return Item.make(
      "Creepy",
      Glyphs.RatSkull,
      "Rat Skull",
      "The toothy skull of a very large dire rat."
    );
  }

  static sunflowerSeeds() {
    return Item.make(
      "Rustic",
      Glyphs.Seeds,
      "Sunflower Seeds",
      "Plant these in the spring."
    );
  }

  static groat() {
    return Item.make(
      "Antiquarian",
      Glyphs.Coin,
      "Silver Groat",
      "A worn and mishapen ancient coin made of tarnished silver."
    );
  }

  static eyeballJar() {
    return Item.make(
      "Creepy",
      Glyphs.EyeballJar,
      "Eye in a Jar",
      "A floating eyeball preserved in a jar. It occasionally twitches."
    );
  }

  static ebonyComb() {
    return Item.make(
      "Gothic",
      Glyphs.EbonyComb,
      "Ebony Comb",
      "An ornate fine-toothed comb with intricate carvings."
    );
  }
}

export default Items;
